import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=ce1ff070&scoped=true&lang=pug"
import script from "./ratings.vue?vue&type=script&lang=ts"
export * from "./ratings.vue?vue&type=script&lang=ts"
import style0 from "./ratings.vue?vue&type=style&index=0&id=ce1ff070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1ff070",
  null
  
)

export default component.exports